import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Permette a un componente ospitato nel pannello sidebar (HomeComponent) di forzare la larghezza
 * del pannello indipendentemente dal flag statico `wide` della sua voce di toolbar — usato dalle
 * sezioni che cambiano vista internamente (es. mappa vs. dettaglio) e hanno bisogno di larghezze
 * diverse per vista. `null` = nessun override, si usa il default della voce di toolbar.
 */
@Injectable({
  providedIn: 'root'
})
export class SidePanelService {
  public wideOverride$: BehaviorSubject<boolean | null> = new BehaviorSubject<boolean | null>(null);
  public halfOverride$: BehaviorSubject<boolean | null> = new BehaviorSubject<boolean | null>(null);
}
